const HTML_MATCH_REGEX = /<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g;

function stripHtmlTags(htmlCode) {
  let html = decodeHtml(htmlCode);
  return html.replace(HTML_MATCH_REGEX, '');
}

function decodeHtml(htmlCode) {
  try {
    return decodeURIComponent(htmlCode);
  } catch (e) {
    return htmlCode;
  }
}

export {
  stripHtmlTags,
}
